import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, shallowRef } from 'vue'

import {
  MicrofrontendEvents,
  showCreateShipmentFlow,
  publish,
} from '@sennder/senn-node-microfrontend-event-bus'
import { ISennTmsSharedData } from '@sennder/senn-node-microfrontend-interfaces'
import {
  createMfWrapper,
  MicroFrontendLogger,
  ComponentDefinition,
} from '@sennder/shell-utilities'

import { isLocalEnv } from '@/common/config'
import { wrapAuthWithLogging } from '@/modules/utils'
import { AppAnalyticsProvider } from '@/services/analyticsProvider'
import { logger } from '@/services/logger/loggers'
import { getStateCallbacks, getStateProviders } from '@/store'
import { logout } from '@/store/logoutActions'
import router from '@/router'

import { loggerInstance } from '@/services/logger'
import { microfrontends } from '@/config/microfrontends'
import { getMicrofrontendData } from '@/router/routes'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateShipment',
  setup(__props) {

const loaded = ref(false)
const mfWrapper = shallowRef<ComponentDefinition>()

const module = microfrontends.shipment_modal

const analyticsContext = {
  module: 'create-shipment',
  submodule: '',
}

const logContext = {
  codeOwners: 'ingestion',
  module: 'create-shipment',
}

const analyticsProvider = new AppAnalyticsProvider(analyticsContext)
const mfLogger = new MicroFrontendLogger(logContext, () => loggerInstance)

const { getAuthHeader, getAuthToken, getToken } = getStateCallbacks()

const onAddShipmentClick = () => {
  publish<showCreateShipmentFlow>({
    name: MicrofrontendEvents.showCreateShipmentFlow,
    data: {},
  })
}

onMounted(async () => {
  mfWrapper.value = await createMfWrapper<ISennTmsSharedData>({
    allowEnvironmentOverrides: isLocalEnv(),
    getData: async () => ({
      data: getMicrofrontendData(module.npmName),
      callbacks: {
        ...getStateCallbacks(),
        getAuthHeader: wrapAuthWithLogging(getAuthHeader, mfLogger),
        getAuthToken: wrapAuthWithLogging(getAuthToken, mfLogger),
        getToken: wrapAuthWithLogging(getToken, mfLogger),
        onUnauthorized: async () => {
          await logout()
        },
        // modal widget will redirect to created shipment draft
        syncParentRouter: (route) => {
          router.push(route)
        },
      },
      providers: getStateProviders(),
    }),
    hooks: {
      failure: logger.error,
    },
    mf: {
      id: 'create-shipment-widget-new',
      fml: module,
      context: {
        analytics: analyticsContext,
        logger: logContext,
      },
    },
    providers: {
      getAnalytics: () => analyticsProvider,
      getLogger: () => mfLogger,
    },
    router,
  })

  loaded.value = true
})

return (_ctx: any,_cache: any) => {
  const _component_dsf_navbar_item = _resolveComponent("dsf-navbar-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dsf_navbar_item, _mergeProps(_ctx.$attrs, {
      dsf_icon: "CirclePlus",
      dsf_title: _ctx.$t('navigation.item.add-new-cargo'),
      dsf_id: "create_shipment",
      onNavigate: _withModifiers(onAddShipmentClick, ["stop"]),
      disabled: !loaded.value
    }), null, 16 /* FULL_PROPS */, ["dsf_title", "disabled"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(mfWrapper.value)))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})